if (import.meta.hot) {
  import.meta.hot.accept();
}

// Apple MapKit JS map: pins + native clustering, gated behind consent (see
// LocationMap.html — this module is always loaded/inert, `initAltanaLocationMap`
// is only ever called from the consent-blocked inline script once the
// mapkit.js SDK itself has loaded). Reads the same location data the
// server-rendered accordion list is built from (embedded as JSON) so the map
// and the list never disagree.

const CLUSTER_ID = 'location-finder';

// Pin/cluster glyphs, inlined as markup (same convention as location-finder.js's
// TAG_REMOVE_ICON/PAGINATION_ARROW_ICONS) rather than the `<altana:icon>` Fluid
// ViewHelper, which only works server-side — these are baked into MapKit
// annotations built entirely in JS. Sourced from
// packages/altana-base/Resources/Private/Assets/Icons/functional/{briefcase-blank,cart-shopping,arrow-down-to-line,arrow-up-right}.svg.
const PIN_ICON_DEFAULT = '<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 1.5C1.725 1.5 1.5 1.725 1.5 2V14C1.5 14.275 1.725 14.5 2 14.5H4.5V12C4.5 11.4469 4.94688 11 5.5 11H6.5C7.05312 11 7.5 11.4469 7.5 12V14.5H10C10.275 14.5 10.5 14.275 10.5 14V2C10.5 1.725 10.275 1.5 10 1.5H2ZM0 2C0 0.896875 0.896875 0 2 0H10C11.1031 0 12 0.896875 12 2V14C12 15.1031 11.1031 16 10 16H2C0.896875 16 0 15.1031 0 14V2ZM3 3.5C3 3.225 3.225 3 3.5 3H4.5C4.775 3 5 3.225 5 3.5V4.5C5 4.775 4.775 5 4.5 5H3.5C3.225 5 3 4.775 3 4.5V3.5ZM7.5 3H8.5C8.775 3 9 3.225 9 3.5V4.5C9 4.775 8.775 5 8.5 5H7.5C7.225 5 7 4.775 7 4.5V3.5C7 3.225 7.225 3 7.5 3ZM3 7.5C3 7.225 3.225 7 3.5 7H4.5C4.775 7 5 7.225 5 7.5V8.5C5 8.775 4.775 9 4.5 9H3.5C3.225 9 3 8.775 3 8.5V7.5ZM7.5 7H8.5C8.775 7 9 7.225 9 7.5V8.5C9 8.775 8.775 9 8.5 9H7.5C7.225 9 7 8.775 7 8.5V7.5C7 7.225 7.225 7 7.5 7Z" fill="white"/></svg>';
const PIN_ICON_DISTRIBUTOR = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.9344 4.55938C3.26252 3.625 4.14377 3 5.1344 3H14.8906C15.8813 3 16.7625 3.625 17.0906 4.55938L17.6656 6.20312C18.0094 7.1875 17.6969 8.2 17.0125 8.84062V14.7531C17.0125 15.9969 16.0063 17.0031 14.7625 17.0031H5.26252C4.01877 17.0031 3.01252 15.9969 3.01252 14.7531V8.84062C2.32815 8.2 2.01565 7.1875 2.3594 6.20312L2.9344 4.55938ZM4.51252 9.49375V12H15.5125V9.49375C15.45 9.49688 15.3906 9.5 15.3281 9.5C14.6469 9.5 14.0219 9.22187 13.5719 8.77187C13.1156 9.22187 12.4906 9.5 11.7938 9.5C11.1 9.5 10.4688 9.21875 10.0125 8.76562C9.55627 9.21875 8.92502 9.5 8.23127 9.5C7.5344 9.5 6.9094 9.22187 6.45315 8.77187C6.00315 9.225 5.38127 9.5 4.6969 9.5C4.6344 9.5 4.5719 9.49688 4.5094 9.49375H4.51252ZM7.44065 4.5L7.20315 6.86562C7.14377 7.47187 7.61877 8 8.22815 8C8.7969 8 9.2594 7.5375 9.2594 6.96875V4.5H7.43752H7.44065ZM10.7625 6.96875C10.7625 7.5375 11.225 8 11.7938 8C12.4031 8 12.8813 7.47187 12.8188 6.86562L12.5813 4.5H10.7594V6.96875H10.7625ZM14.3531 7.11875C14.4031 7.61875 14.825 8 15.325 8C16 8 16.4719 7.33437 16.2469 6.7L15.675 5.05625C15.5594 4.72188 15.2438 4.5 14.8906 4.5H14.0906L14.3531 7.11875ZM4.70002 8C5.20315 8 5.6219 7.61875 5.6719 7.11875L5.9344 4.5H5.1344C4.78127 4.5 4.46877 4.72188 4.35002 5.05625L3.77502 6.7C3.55315 7.3375 4.02502 8 4.6969 8H4.70002ZM4.51252 14.75C4.51252 15.1656 4.8469 15.5 5.26252 15.5H14.7625C15.1781 15.5 15.5125 15.1656 15.5125 14.75V13.5H4.51252V14.75Z" fill="white"/></svg>';
// arrow-down.svg's viewBox is cropped from the 24px grid to its 16px glyph area
// so it renders 1:1 (1.5px stroke) at 16px, matching ICON_DIRECTIONS' 16px grid.
const ICON_SHOW_DETAILS = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="4 4 16 16"><path fill="currentColor" d="M11.484 19.781a.747.747 0 0 0 1.06 0l5.25-5.25a.75.75 0 0 0-1.06-1.06l-3.968 3.97V4.75a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v12.69l-3.97-3.968a.75.75 0 0 0-1.06 1.06l5.252 5.25z"/></svg>';
const ICON_DIRECTIONS = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.68462 7.36754L2.4815 5.96442L13.1284 1.87067L9.03462 12.5175L7.6315 8.31442C7.4815 7.86754 7.1315 7.51442 6.6815 7.36442L6.68462 7.36754ZM9.93462 14.3582L14.9346 1.35817C15.0752 0.989418 14.9877 0.570668 14.7096 0.292543C14.4315 0.0144182 14.0127 -0.0762068 13.644 0.0675432L0.643999 5.06754C0.247124 5.21754 -0.00912615 5.59879 0.000248853 6.02067C0.00962385 6.44254 0.284624 6.81442 0.684624 6.94567L6.20962 8.78629L8.05025 14.3113C8.18462 14.7113 8.55337 14.9863 8.97525 14.9957C9.39712 15.005 9.77837 14.7488 9.9315 14.355L9.93462 14.3582Z" fill="currentColor"/></svg>';
const ICON_CLOSE = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M4.234 5.281a.756.756 0 0 1 0-1.062.754.754 0 0 1 1.063 0l6.719 6.719 6.718-6.72a.75.75 0 0 1 1.06 1.06l-6.719 6.719 6.719 6.719a.75.75 0 0 1-1.06 1.06l-6.718-6.72-6.72 6.719a.75.75 0 0 1-1.06-1.06l6.72-6.718-6.718-6.719z"/></svg>';

function readLocations() {
  const script = document.getElementById('location-finder-data');
  if (!script) {
    return [];
  }
  try {
    return JSON.parse(script.textContent);
  } catch {
    return [];
  }
}

function buildCallout(location, labels, onClose) {
  const el = document.createElement('div');
  el.className = 'location-map__callout';

  // MapKit doesn't wrap factory-built mapkit.Annotation callouts in any
  // chrome of its own (no background, no dismiss control) — that's only
  // provided automatically for its built-in MarkerAnnotation callouts. Both
  // are rebuilt here from scratch (see location-map.scss for the card look).
  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'location-map__callout-close';
  close.setAttribute('aria-label', labels.close || 'Close');
  close.innerHTML = ICON_CLOSE;
  close.addEventListener('click', onClose);
  el.appendChild(close);

  if (location.typeLabel) {
    const category = document.createElement('p');
    category.className = 'location-map__callout-category';
    category.textContent = location.typeLabel;
    el.appendChild(category);
  }

  const name = document.createElement('p');
  name.className = 'location-map__callout-name';
  name.textContent = location.name;
  el.appendChild(name);

  // One line per part (street(s), ZIP + city, province, country, region) —
  // mirrors the list's <address> block in LocationItem.html instead of
  // squashing everything into one comma-separated line.
  const addressLines = [...(location.address || []), location.country, location.regionLabel].filter(Boolean);
  if (addressLines.length) {
    const address = document.createElement('address');
    address.className = 'location-map__callout-address';
    addressLines.forEach((line, index) => {
      if (index > 0) {
        address.appendChild(document.createElement('br'));
      }
      address.append(line);
    });
    el.appendChild(address);
  }

  const actions = document.createElement('div');
  actions.className = 'location-map__callout-actions';

  const showDetails = document.createElement('button');
  showDetails.type = 'button';
  showDetails.className = 'location-map__callout-action';
  showDetails.insertAdjacentHTML('afterbegin', ICON_SHOW_DETAILS);
  showDetails.append(labels.showDetails || 'Show Details');
  showDetails.addEventListener('click', () => {
    if (window.locationFinderShowDetails) {
      window.locationFinderShowDetails(location.id);
    }
  });
  actions.appendChild(showDetails);

  if (location.directionsUrl) {
    const directions = document.createElement('a');
    directions.href = location.directionsUrl;
    directions.target = '_blank';
    directions.rel = 'noopener';
    directions.className = 'location-map__callout-action';
    directions.insertAdjacentHTML('afterbegin', ICON_DIRECTIONS);
    directions.append(labels.directions || 'Get directions');
    actions.appendChild(directions);
  }

  el.appendChild(actions);
  return el;
}

const CLUSTER_MAX_DISPLAY = 99;

function createClusterElement(count) {
  const el = document.createElement('div');
  el.className = 'location-map__cluster';
  el.textContent = count > CLUSTER_MAX_DISPLAY ? `${CLUSTER_MAX_DISPLAY}+` : String(count);
  return el;
}

// A rounded-square rotated 45° with a square bottom-left corner reads as a
// downward-pointing teardrop — the icon inside is counter-rotated to stay
// upright. `anchorOffset` (see below) shifts it up by half its height so the
// teardrop's tip, not its bounding-box center, lands on the coordinate.
function createPinElement(location) {
  const el = document.createElement('div');
  el.className = 'location-map__pin';

  const icon = document.createElement('span');
  icon.className = 'location-map__pin-icon';
  icon.innerHTML = location.isDistributor ? PIN_ICON_DISTRIBUTOR : PIN_ICON_DEFAULT;
  el.appendChild(icon);

  return el;
}

// Locations sharing an exact lat/lon (e.g. two companies at one office
// address) would otherwise sit on the identical screen pixel at every zoom
// level — MapKit's clustering can never visually split them apart, so
// neither pin is ever individually selectable. Nudging every repeat a tiny
// bit further along a spiral around the shared point (small enough to stay
// invisible zoomed out, large enough to separate once zoomed in) keeps them
// clustering together at low zoom while still letting each one resolve to
// its own clickable pin at high zoom.
function jitteredCoordinate(lat, lon, repeatIndex) {
  if (repeatIndex === 0) {
    return new window.mapkit.Coordinate(lat, lon);
  }
  const angle = repeatIndex * 2.4;
  // ~220m per step (1deg latitude is ~111km). A smaller nudge (~33m, tried
  // originally) only separated at an unreasonably deep zoom; a much larger
  // one (~1.1km, tried after that) visibly displaced the pin from its real
  // address well before that zoom. This is the balance: enough to resolve
  // within a normal zoom-in, small enough that the pin still reads as "at"
  // the real location once it does.
  const radius = 0.002 * repeatIndex;
  return new window.mapkit.Coordinate(lat + radius * Math.cos(angle), lon + radius * Math.sin(angle));
}

const FOCUSABLE_SELECTOR = 'a[href], area[href], button, input, select, textarea, iframe, [tabindex], [contenteditable]';

// The accordion list rendered alongside the map already offers every
// location (and more) in an accessible form, so the map is a pointer-only
// visual extra: keep it — and everything MapKit injects into it later (pins,
// clusters, callouts, zoom/compass controls, legal links) — out of the tab
// order and the accessibility tree. Not `inert`, which would also block
// mouse/touch interaction. The observer also catches MapKit re-adding a
// tabindex to elements it already created.
function hideFromKeyboard(container) {
  container.setAttribute('aria-hidden', 'true');

  const removeFromTabOrder = () => {
    [container, ...container.querySelectorAll(FOCUSABLE_SELECTOR)].forEach((el) => {
      if (el.getAttribute('tabindex') !== '-1' && el.matches(FOCUSABLE_SELECTOR)) {
        el.setAttribute('tabindex', '-1');
      }
    });
  };

  removeFromTabOrder();
  new MutationObserver(removeFromTabOrder).observe(container, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['tabindex', 'href', 'contenteditable'],
  });
}

function initMap(root, locations) {
  const canvas = root.querySelector('[data-map-canvas]');
  const fallback = root.querySelector('[data-map-fallback]');
  if (!canvas) {
    return;
  }

  const labels = {
    showDetails: root.dataset.showDetailsLabel,
    directions: root.dataset.directionsLabel,
    close: root.dataset.closeLabel,
  };

  hideFromKeyboard(canvas);

  const map = new window.mapkit.Map(canvas);

  // Callout customization is per-annotation (`annotation.callout`), not a
  // map-wide delegate — `map.delegate.calloutElementForAnnotation` is never
  // consulted by MapKit JS. One shared, stateless object is fine since every
  // pin's own `annotation.data` already carries what buildCallout() needs.
  const calloutDelegate = {
    calloutElementForAnnotation(annotation) {
      if (!annotation.data) {
        return null;
      }
      return buildCallout(annotation.data, labels, () => {
        annotation.selected = false;
      });
    },
  };

  const coordinateRepeats = new Map();

  const annotations = locations
    .filter((location) => location.lat && location.lon)
    .map((location) => {
      const key = `${location.lat},${location.lon}`;
      const repeatIndex = coordinateRepeats.get(key) || 0;
      coordinateRepeats.set(key, repeatIndex + 1);

      const annotation = new window.mapkit.Annotation(
        jitteredCoordinate(parseFloat(location.lat), parseFloat(location.lon), repeatIndex),
        () => createPinElement(location),
        {
          clusteringIdentifier: CLUSTER_ID,
          calloutEnabled: true,
          title: location.name,
          anchorOffset: new DOMPoint(0, -16),
          callout: calloutDelegate,
          // Matches .location-map__pin's actual CSS size — without this,
          // showItems()'s padding math has to guess before the annotation's
          // real DOM element exists to measure, which MapKit warns about.
          size: { width: 32, height: 32 },
        }
      );
      annotation.data = location;
      return annotation;
    });

  // MapKit builds cluster annotations using the same constructor as their
  // members by default (a navy MarkerAnnotation balloon with a numeric
  // glyph) — swap in a plain circular badge instead, matching the design's
  // visual distinction between a single-location pin and a group.
  map.annotationForCluster = (clusterAnnotation) => {
    const count = clusterAnnotation.memberAnnotations.length;
    const cluster = new window.mapkit.Annotation(clusterAnnotation.coordinate, () => createClusterElement(count), {
      calloutEnabled: false,
      // Matches .location-map__cluster's actual CSS size — see the pin
      // annotation's `size` option above for why this is needed.
      size: { width: 36, height: 36 },
    });
    // `memberAnnotations` is a getter-only property on mapkit.Annotation —
    // stash the list under our own key instead (read back in the 'select'
    // handler below) so clicking a cluster can still zoom into its members.
    cluster.clusterMembers = clusterAnnotation.memberAnnotations;
    return cluster;
  };

  // Keeps pins from ever sitting flush against the map's edge — without
  // this, a callout opened near the boundary gets clipped by MapKit's own
  // canvas bounds (it only knows the map's box, not the surrounding page),
  // cutting off "Show Details"/"Get directions" and making them unclickable.
  const FIT_PADDING = new window.mapkit.Padding(60, 60, 60, 60);

  map.addEventListener('select', (event) => {
    const annotation = event.annotation;
    if (!annotation) {
      return;
    }
    // `annotation.data` defaults to `{}` (truthy) on plain mapkit.Annotation
    // instances, so it can't tell a cluster apart from a pin with no data —
    // `clusterMembers` (only ever set in annotationForCluster above) can.
    // Zoom in one step and re-center instead of showing a callout.
    if (annotation.clusterMembers) {
      map.showItems(annotation.clusterMembers, { animate: true, padding: FIT_PADDING });
      return;
    }
    // A single pin's callout still renders wherever it fits inside the
    // *current* view — on the narrower mobile map a pin near an edge leaves
    // too little room and the card gets clipped. The callout always opens
    // above the pin, so centering the pin itself isn't enough on a short
    // viewport: push the pin toward the lower part of the frame instead
    // (shift the camera center north by a fraction of the visible span),
    // leaving the callout's usual space above it clear.
    const span = map.region.span;
    map.setCenterAnimated(
      new window.mapkit.Coordinate(annotation.coordinate.latitude + span.latitudeDelta * 0.2, annotation.coordinate.longitude),
      true
    );
  });

  // Mirrors the list's filter bar (location-finder.js): only pins whose
  // location is still in the filtered list stay on the map, and the view
  // re-fits to them. `ids === null` means no filter state known yet.
  let shownAnnotations = [];
  function showOnly(ids, fit) {
    const visible = ids ? annotations.filter((annotation) => ids.includes(String(annotation.data.id))) : annotations;
    const toRemove = shownAnnotations.filter((annotation) => !visible.includes(annotation));
    const toAdd = visible.filter((annotation) => !shownAnnotations.includes(annotation));
    if (toRemove.length) {
      map.removeAnnotations(toRemove);
    }
    if (toAdd.length) {
      map.addAnnotations(toAdd);
    }
    shownAnnotations = visible;
    if (fit && visible.length) {
      map.showItems(visible, { animate: true, padding: FIT_PADDING });
    }
  }

  // The filter state may already exist (finder script ran before the map
  // was initialised after consent) — start from it instead of all pins.
  const initialIds = window.locationFinderVisibleIds || null;
  showOnly(initialIds, false);
  map.showItems(shownAnnotations.length ? shownAnnotations : annotations, { padding: FIT_PADDING });

  document.addEventListener('location-finder:filter', (event) => showOnly(event.detail.ids, true));

  if (fallback) {
    fallback.hidden = true;
  }
  canvas.hidden = false;
}

window.initAltanaLocationMap = function initAltanaLocationMap() {
  const root = document.querySelector('[data-location-map]');
  if (!root || root.dataset.mapInitialized === '1') {
    return;
  }
  root.dataset.mapInitialized = '1';

  const locations = readLocations();

  // Baked into this (cached) page's HTML server-side rather than fetched —
  // see LocationfinderController/LocationMap.html — so `done` is called
  // immediately with whatever token this page render embedded, both on
  // first init and whenever MapKit JS calls this again to renew one nearing
  // expiry.
  const token = root.dataset.mapkitToken || '';
  window.mapkit.init({
    authorizationCallback: (done) => done(token),
  });

  initMap(root, locations);
};

// The consent card is hidden until the CMP reports whether the MapKit vendor
// was already accepted; otherwise it flashes briefly on every page load for
// visitors who consented earlier (the map only replaces it once the CMP has
// released the gated init script and mapkit.js has loaded).
function revealConsentCard() {
  const root = document.querySelector('[data-location-map]');
  if (root && root.dataset.mapInitialized !== '1') {
    root.dataset.consentState = 'required';
    root.querySelectorAll('[data-map-consent-card]').forEach((el) => {
      el.hidden = false;
    });
  }
}

function resolveConsentCard() {
  const root = document.querySelector('[data-location-map]');
  if (!root) {
    return;
  }
  const vendorId = root.dataset.cmpVendor;
  if (typeof window.__cmp !== 'function' || !vendorId) {
    revealConsentCard();
    return;
  }

  // The CMP stub answers `getCMPData` synchronously with empty data
  // (no vendors, consentExists=false) until consentmanager.net has fully
  // loaded — treating that as "no consent" would flash the card for visitors
  // who already consented. Poll until the vendor list is populated; the
  // deadline is a safety net so the card is never left hidden.
  const POLL_INTERVAL = 100;
  const DEADLINE = Date.now() + 5000;

  const check = () => {
    window.__cmp('getCMPData', null, (data) => {
      const vendorConsents = data && data.vendorConsents;
      const ready = vendorConsents && Object.keys(vendorConsents).length > 0;
      if (ready && vendorConsents[vendorId] === true) {
        root.dataset.consentState = 'granted';
      } else if (ready || Date.now() > DEADLINE) {
        revealConsentCard();
      } else {
        window.setTimeout(check, POLL_INTERVAL);
      }
    });
  };
  check();
}

resolveConsentCard();

// This module is loaded as `type="module"`, which the browser always defers
// to after synchronous script parsing. LocationMap.html's consent-gated
// script normally only calls `initAltanaLocationMap` from a dynamically
// injected mapkit.js `load` handler — always well after this module has
// run — but if consentmanager.net's autoblocking doesn't recognise the
// configured vendor and lets that script fire unblocked immediately, it can
// call `initAltanaLocationMap` before this line has had a chance to define
// it (see location-map-loader's guarded call in LocationMap.html). Self-
// invoke here to catch that case: if `window.mapkit` is already loaded by
// the time this deferred module runs, the map was never actually started.
if (window.mapkit) {
  window.initAltanaLocationMap();
}

import './location-map.scss';
